import React from 'react'

function PharmacySalesReports() {
  return (
    <div>Pharmacy Sales Reports</div>
  )
}

export default PharmacySalesReports